var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.sorting.length > 0)?_c('div',{staticClass:"has-text-right"},[_vm._v(" "+_vm._s(_vm.props.label)+" "+_vm._s(_vm.props.sorting[0].name)+" "),_c('a',{on:{"click":function($event){return _vm.listeners['clear-sorting']()}}},[_vm._v("x")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }